(function ($, Drupal, window, document) {
  'use strict';

  Drupal.behaviors.degree_programs = {
    attach: function degree_programs(context, settings) {
      if (typeof context['location'] !== 'undefined') {
        // document has loaded.
        window.degreeViewOptions.bindEvents();
      } else {
        document.addEventListener('DOMContentLoaded', window.degreeViewOptions.bindEvents)
      }
    }
  };

  window.degreeViewOptions = {
    // eventsBound: false,
    isIos() {
      const ua = navigator.userAgent
      return (ua.includes('iPhone') || ua.includes('iPad'))
    },
    getView() {
      var href = new URL(document.location.href);
      return href.searchParams.get('view');
    },
    updateSearchURI(target) {
      try {
        // Set GET param (view=grid)
        var href = new URL(document.location.href);
        href.searchParams.set('view', target);
        window.history.replaceState(null, null, href.toString());
      } catch (err) {

      }
    },
    openFilters() {
      // Show Grid
      $('.fieldset__view-filters.tray')
        .addClass('active')
        .attr('aria-hidden', 'false');

      $('body').addClass('no-scroll');
    },
    closeFilters() {
      // Hide Grid
      $('.fieldset__view-filters.tray')
        .removeClass('active filters-open search-open')
        .attr('aria-hidden', 'true');

      $('body').removeClass('no-scroll');
    },
    showGridView() {
      // Hide List
      $('.degree-program__list')
        .removeClass('active')
        .attr('aria-hidden', 'true');

      // Show Grid
      $('.degree-program__grid')
        .addClass('active')
        .attr('aria-hidden', 'false');

      window.degreeViewOptions.updateSearchURI("grid");

    },
    showListView() {
      // Hide Grid
      $('.degree-program__list')
        .addClass('active')
        .attr('aria-hidden', 'false');

      // Show List
      $('.degree-program__grid')
        .removeClass('active')
        .attr('aria-hidden', 'true');

      window.degreeViewOptions.updateSearchURI("list");
    },
    setDefaultView() {
      // For ios limit to list view only
      if (window.degreeViewOptions.isIos()) {
        window.degreeViewOptions.showListView();
        document.querySelector('.degree-program__view-toggles').classList.add('visually-hidden')
      } else {
        (window.degreeViewOptions.getView() == 'list') ? window.degreeViewOptions.showListView(): window.degreeViewOptions.showGridView();

        // Set the correct button to active
        $('.degree-program__toggle').removeClass('active');
        $(`button[data-target="${window.degreeViewOptions.getView()}"]`).addClass('active');
      }
    },
    bindEvents() {
      // if !(this.eventsBound) {
        // On ajax reload, set the default view
        $(document).ready(window.degreeViewOptions.setDefaultView);

        // On ajax reload, set the default view
        $(document).ajaxComplete(function () {
          window.degreeViewOptions.setDefaultView()
          // Make sure view is scrollable (mobile only)
          $('body').removeClass('no-scroll');
        });

        // Toggle mobile filters
        $('.degree-program__tray-toggle').on('click', function (e) {
          const currentToggle = $(this);
          const target = $(this).data('target');

          // Toggle tray menu
          const isOpen = $('.fieldset__view-filters.tray').hasClass('active');

          // Toggle view
          (isOpen) ? window.degreeViewOptions.closeFilters(): window.degreeViewOptions.openFilters();
        });


        $('.degree-program__tray-toggle.filters').on('click', function (e) {
          $('.fieldset__view-filters.tray').addClass('filters-open');
        });


        $('.degree-program__tray-toggle.search').on('click', function (e) {
          $('.fieldset__view-filters.tray').addClass('search-open');
        });

        // Toggle grid/list layouts
        $('.degree-program__toggle').on('click', function (e) {
          const currentToggle = $(this);
          const targetToggle = currentToggle.siblings('.active');
          const target = $(this).data('target');

          // Toggle buttons
          targetToggle.removeClass('active');
          currentToggle.addClass('active');

          // this.updateSearchURI('target');

          // Toggle view
          (target == 'grid') ? window.degreeViewOptions.showGridView(): window.degreeViewOptions.showListView();
        });

        // this.eventsBound = true;
      // }
    }
  };
})(jQuery, Drupal, window, document);
